import { UsersService } from '../../shared/services/users.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from '../../shared/services/notifications.service';
import { ThemeService } from '../../shared/services/theme.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {


    public loginFormModel = { username: "", password: "" };

    @ViewChild("recoverPasswordModalContent", { static: false })
    public recoverPasswordModal: TemplateRef<any>;
    public recoverPasswordFormModel = {};

    constructor(
        private authenticationService: AuthenticationService
        , private usersService: UsersService
        , private router: Router
        , private modalService: NgbModal
        , private spinner: NgxSpinnerService
        , private notifications: NotificationsService
        , private themeService: ThemeService) { }

    ngOnInit(): void {
        this.themeService.toggleDark();
    }

    loginClicked(form) {
        if (!form.valid) {
            Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());
            return;
        }

        this.spinner.show();
        this.authenticationService.login(this.loginFormModel.username, this.loginFormModel.password).subscribe(response => {
            this.spinner.hide();
            if (!response.success) {
                this.notifications.errors(response.payload.messages);
                return;
            }

            this.router.navigate(["/"]);
        });
    };

    recoverPasswordClicked() {
        this.recoverPasswordFormModel = { username: this.loginFormModel.username };
        this.modalService.open(this.recoverPasswordModal, { size: 'lg', backdrop: 'static', keyboard: false });
    };

    recoverPasswordConfirmClicked(form) {
        if (!form.valid) {
            Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());
            return;
        }

        this.spinner.show();
        this.usersService.requestPasswordRecoveryToken(this.recoverPasswordFormModel).subscribe(response => {
            this.spinner.hide();
            if (!response.success) {
                if (response.payload.messages)
                    this.notifications.errors(response.payload.messages);
                else
                    this.notifications.error("A recuperação de senha não pôde ser realizada para o usuário informado.");
                return;
            }

            this.notifications.success("Um e-mail com o link para recuperação de sua senha foi enviado.");
            this.modalService.dismissAll();
        });
    }
}
